import { MgmMainPageResourcesEn } from "@/src/member-get-member/MainPage/MgmMainPage.Resources.En";

export const MgmLandingPageResourcesEn = {
    goodieAdvantagesTitle: "<b>Advantages</b> of goodie cashback ",

    lpDashboard: {
        title: "Recommend and <b>earn</b>",
        recommendedLabel: "Recommend goodie cashback to your friends and together catch bonuses!",
        bonusLabel: MgmMainPageResourcesEn.dashboard.bonusDescription,
        signUpLabel: "Sign up or log in and start recommend.",
        loginText: "Login",
        registerText: "Register",
    },
};
